import React, { useContext, useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import httpRequest from "../../httpRequest";
import OCRContext from "../../context/ocr-context";
import UserContext from "../../context/user-context";
import { LinearProgress } from "@mui/material";
import { MessageStrip } from "@ui5/webcomponents-react";
import { useStyles } from "./styles";

const OCRCard = () => {
  const ocrCtx = useContext(OCRContext);
  const userCtx = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [hasRun, setHasRun] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  useEffect(() => {
    if (hasRun || !ocrCtx.file) return;

    const handleOCR = async () => {
      setLoading(true);
      setHasRun(true);

      let formData = new FormData();
      formData.append("pdf", ocrCtx.file);
      formData.append("vendor_code", ocrCtx.vendorCode || "");
      formData.append("employee_code", userCtx.employeeCode || "");
      formData.append("company_id", ocrCtx.companyId || "");
      formData.append("function_id", ocrCtx.functionId || "");
      formData.append("position_id", userCtx.employeeData?.position_id || "");

      if (ocrCtx.attachments && ocrCtx.attachments.length > 0) {
        ocrCtx.attachments.forEach((attachment, index) => {
          formData.append(`attachment_${index}`, attachment.file);
          formData.append(`attachment_filetype_${index}`, attachment.file.type);
          formData.append(`attachment_filename_${index}`, attachment.fileName);
        });
      }

      try {
        const resp = await httpRequest.post(
          `${process.env.REACT_APP_BACKEND_URL}/engine`,
          formData
        );

        const parsedData = JSON.parse(resp.data.parsed_data || "{}");
        const isInvoiceEmpty =
          !parsedData["Document Number"] || parsedData["Document Number"] === "";
        const invoiceNumber = parsedData["Document Number"] || "";

        ocrCtx.setIsInvoice(!isInvoiceEmpty);
        ocrCtx.setInvoiceNumber(invoiceNumber);

        const extractedData = {
          parsed_data: resp.data.parsed_data,
          id: resp.data.invoice_id,
        };

        const rawVendorData = {
          vendor_data: resp.data.vendor_data,
        };

        ocrCtx.setExtractedData(extractedData);
        ocrCtx.setInvoiceId(resp.data.invoice_id);
        ocrCtx.setVendorCode(resp.data.vendor_code);
        ocrCtx.setRawVendorData(rawVendorData);

        setLoading(false);
        ocrCtx.setActivePage(2);
      } catch (error) {
        console.error("OCR Error:", error.response?.data || error.message);
        enqueueSnackbar("Failed to process OCR", { variant: "error" });
        setLoading(false);
      }
    };

    handleOCR();
  }, [
    ocrCtx.file,
    ocrCtx.vendorCode,
    ocrCtx.companyId,
    ocrCtx.functionId,
    userCtx.employeeCode,
    userCtx.employeeData,
  ]);

  return (
    <>
      {loading && <LinearProgress />}
      <div className={classes.rootContainer}>
        <MessageStrip design="Information" hideCloseButton>
          {loading ? "Scanning in Progress" : "Processing Complete"}
        </MessageStrip>
      </div>
    </>
  );
};

export default OCRCard;